import React from 'react';

// Search + filter + actions row above each table. Keeps tabs visually consistent.
const Toolbar = ({ children }) => (
    <div className="admin-toolbar">{children}</div>
);

export const Pager = ({ page, totalPages, onChange }) => {
    if (!totalPages || totalPages <= 1) return null;
    return (
        <div className="admin-pager">
            <button
                className="btn-ghost"
                disabled={page <= 1}
                onClick={() => onChange(page - 1)}
            >
                ‹ Prev
            </button>
            <span className="pager-label">
                Page {page}{totalPages ? ` / ${totalPages}` : ''}
            </span>
            <button
                className="btn-ghost"
                disabled={totalPages && page >= totalPages}
                onClick={() => onChange(page + 1)}
            >
                Next ›
            </button>
        </div>
    );
};

export default Toolbar;
